import { defineNuxtPlugin } from '#app';
import { ref, toRaw } from '#imports';
import { debounce } from 'lodash-es';

export default defineNuxtPlugin(nuxtApp => {
    const limits = {
        smallMobile: 320,
        mobile: 480,
        largeMobile: 768,
        smallDesktop: 992,
        desktop: 1200,
        largeDesktop: 1600,
    };

    const bps = ref({
        isSmallMobile: null,
        isMobile: null,
        isLargeMobile: null,
        isSmallDesktop: null,
        isDesktop: null,
        isLargeDesktop: null,
        atMostMobile: null,
        atMostLargeMobile: null,
    });

    const viewportWidth = ref(0);
    const TRACKING_TIMEOUT = 50;

    const checkScreenWidth = (bp, w = 'max-width') => {
        if (typeof matchMedia === 'undefined' || !bp) return null;

        return matchMedia(`(${w}: ${bp}px)`).matches;
    };

    const isScreenMinWidth = bp => checkScreenWidth(bp, 'min-width');
    const isScreenMaxWidth = bp => checkScreenWidth(bp);

    const recalculate = () => {
        viewportWidth.value = window.innerWidth;

        const newBps = {
            isSmallMobile: isScreenMinWidth(limits.smallMobile),
            isMobile: isScreenMinWidth(limits.mobile),
            isLargeMobile: isScreenMinWidth(limits.largeMobile),
            isSmallDesktop: isScreenMinWidth(limits.smallDesktop),
            isDesktop: isScreenMinWidth(limits.desktop),
            isLargeDesktop: isScreenMinWidth(limits.largeDesktop),
            atMostMobile: (isScreenMinWidth(limits.smallMobile) || isScreenMinWidth(limits.mobile)) && isScreenMaxWidth(limits.largeMobile),
            atMostLargeMobile: (isScreenMinWidth(limits.smallMobile) || isScreenMinWidth(limits.mobile) || isScreenMinWidth(limits.largeMobile)) && isScreenMaxWidth(limits.smallDesktop),
        };

        if (nuxtApp.$dsc.object.same(toRaw(bps.value), newBps)) return;

        Object.assign(bps.value, newBps);
    };

    const trackBreakpoints = debounce(() => recalculate(), TRACKING_TIMEOUT);

    const stopTrackingBreakpoints = () => {
        window.removeEventListener('resize', trackBreakpoints);
    };

    const startTrackingBreakpoints = () => {
        stopTrackingBreakpoints();
        recalculate();
        window.addEventListener('resize', trackBreakpoints);
    };

    nuxtApp.hook('page:finish', () => {
        startTrackingBreakpoints();
    });

    return {
        provide: {
            bp: {
                limits,
                bps: bps.value,
                viewportWidth,
                startTrackingBreakpoints,
                stopTrackingBreakpoints,
            },
        },
    };
});
